import { Gem, Flower2, Leaf } from "lucide-react";
import { SectionHeading } from "../common/Primitives";
import { Reveal, RevealImage, Stagger, StaggerItem } from "../motion/Reveal";
import { IMG } from "../../config/site";

const PRINCIPLES = [
  { icon: Gem, title: "Premium quality", text: "Designed around thoughtful presentation and a refined guest experience." },
  { icon: Flower2, title: "Hospitality focused", text: "Created for hotels, restaurants, resorts, and exceptional occasions." },
  { icon: Leaf, title: "Locally crafted", text: "Rooted in Agra, with ambitions to serve hospitality partners beyond it." },
];

export const Story = () => (
  <section id="story" data-testid="story-section" className="relative bg-[#F8F3E9] py-24 sm:py-32">
    <div className="mx-auto grid max-w-[1440px] items-center gap-14 px-5 sm:px-8 lg:grid-cols-[1fr_1.05fr_1fr] lg:gap-16 lg:px-12">
      <div>
        <SectionHeading eyebrow="Our Story" lines={["A Deeper Commitment", "to Hospitality"]} />
        <Reveal delay={0.15}>
          <p className="body-lux mt-8 max-w-md">
            TOYAM was conceived in Agra, a city known for timeless beauty and extraordinary hospitality. We are building a premium
            alkaline water experience in glass bottles for hotels and restaurants that value quality, thoughtful presentation, and responsible packaging.
          </p>
        </Reveal>
      </div>
      <div className="relative mx-auto w-full max-w-[460px]">
        <div aria-hidden="true" className="absolute -inset-3 rounded-t-full border border-[#B18A4A]/40" />
        <RevealImage src={IMG.story} alt="An elegant terrace dinner table framed by a carved Mughal sandstone arch, the Taj Mahal glowing at sunset beyond"
          className="relative aspect-[3/4] rounded-t-full" />
      </div>
      <Stagger className="space-y-10 lg:pl-6">
        {PRINCIPLES.map(({ icon: Icon, title, text }) => (
          <StaggerItem key={title} className="group flex gap-6 border-b border-[#B18A4A]/20 pb-8 last:border-0">
            <span className="grid h-14 w-14 shrink-0 place-items-center rounded-full border border-[#B18A4A]/40 text-[#B18A4A] transition-colors duration-500 group-hover:bg-[#B18A4A] group-hover:text-white">
              <Icon className="h-6 w-6" strokeWidth={1} aria-hidden="true" />
            </span>
            <div>
              <h3 className="font-sans text-xs font-bold uppercase tracking-[0.26em] text-[#26231F]">{title}</h3>
              <p className="body-lux mt-2 !text-[14px]">{text}</p>
            </div>
          </StaggerItem>
        ))}
      </Stagger>
    </div>
  </section>
);
